import type { FC, FormEventHandler, MouseEventHandler } from "react";
import { useEffect } from "react";
import { type Breadcrumb, useBreadcrumb } from "../../../components/Breadcrumb";
import { LoadingUI } from "../../../components/Loading";
import { PageTitle } from "../../../components/PageTitle";
import type {
  DeliveryHistories,
  DeliveryHistory,
  DeliveryHistorySearchInput,
} from "../../../hooks/useDeliveryHistoriesRestApi";
import type { DeliveryOpenRateAnalyticsResponse } from "../../../utils/open-rate-utils";
import { DeliveryHistoriesTableUI } from "./components/DeliveryHistoriesTable";
import type { ChangeDeliveryHistorySearchInput } from "./components/SearchDeliveryHistoriesForm";

type DeliveryHistoriesPageProps = {
  isLoading: boolean;
  searchInput: DeliveryHistorySearchInput;
  onChangeSearchInput: ChangeDeliveryHistorySearchInput;
  deliveryHistories: DeliveryHistories;
  openRates: DeliveryOpenRateAnalyticsResponse;
  openRatesLoaded: boolean;
  onSelectHistory: (id: string) => void;
  onSearch: FormEventHandler;
  onClearFilter: MouseEventHandler;
  onResend: (history: DeliveryHistory) => void;
};

const BREAD_CRUMBS: Breadcrumb[] = [
  {
    label: "ホーム",
    to: "/",
  },
  {
    label: "配信履歴",
  },
];

const DeliveryHistoriesPage: FC<DeliveryHistoriesPageProps> = ({
  isLoading,
  deliveryHistories,
  openRates,
  openRatesLoaded,
  onResend,
}) => {
  const { setBreadcrumbItems } = useBreadcrumb();
  useEffect(() => {
    setBreadcrumbItems(BREAD_CRUMBS);
  }, [setBreadcrumbItems]);

  return (
    <div>
      <PageTitle>配信履歴</PageTitle>
      {isLoading ? (
        <div className="w-full flex justify-center pt-20">
          <LoadingUI type="Grid" />
        </div>
      ) : (
        <div className="flex flex-col">
          <p className="text-sm tracking-widest mb-2.5">
            全
            <span className="font-bold text-lg">
              {deliveryHistories.totalCount}
            </span>
            件中
            <span className="font-bold text-lg">
              {deliveryHistories.nodes.length}
            </span>
            件表示
          </p>
          <div className="flex flex-row space-x-2">
            <div className="w-full">
              <div className="shadow overflow-hidden border-b border-gray-200 rounded-md overflow-y-scroll h-screen">
                <DeliveryHistoriesTableUI
                  deliveryHistories={deliveryHistories.nodes}
                  openRates={openRates}
                  openRatesLoaded={openRatesLoaded}
                  onResend={onResend}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default DeliveryHistoriesPage;
